import { render, staticRenderFns } from "./HomeTeamMemberBox.vue?vue&type=template&id=57869148&"
import script from "./HomeTeamMemberBox.vue?vue&type=script&lang=js&"
export * from "./HomeTeamMemberBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports